// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
    font-size: 20px;
    margin: 10px;
    cursor: pointer;
}

table tbody tr .nameCol {
    cursor: pointer;
}

table thead tr th .emailWith {
    width: "100px" !important;
}

.shopWith {
    width: "100px"
}

.statusWith {
    width: "50px"
}

.DateWith {
    width: "100px"
}

.actionWith {
    width: "100px"
}`, "",{"version":3,"sources":["webpack://./src/Components/Store/StoreTable/StoreTable.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ","sourcesContent":[".icon {\n    font-size: 20px;\n    margin: 10px;\n    cursor: pointer;\n}\n\ntable tbody tr .nameCol {\n    cursor: pointer;\n}\n\ntable thead tr th .emailWith {\n    width: \"100px\" !important;\n}\n\n.shopWith {\n    width: \"100px\"\n}\n\n.statusWith {\n    width: \"50px\"\n}\n\n.DateWith {\n    width: \"100px\"\n}\n\n.actionWith {\n    width: \"100px\"\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
